<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header pb-0">
            <p class="text-uppercase text-center">
              Historial de Pagos con Error
            </p>
            Total: {{ totalFacturas }} | Páginas: {{ totalPages }}
          </div>
          <hr class="horizontal dark" />
          <div class="card-body px-2 pt-2 pb-2">
            <div
              class="d-flex justify-content-center align-items-center py-4"
              v-if="isLoading"
            >
              Cargando Información
              <pulse-loader :loading="isLoading" :color="color" :size="size" />
            </div>

            <div v-else>
              <!-- TABLA -->
               <form role="form" @submit.stop.prevent="getData">
                <div class="row">
                  <div class="col-md-2">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Buscar"
                      v-model="modelPagos.filtro"
                    />
                  </div>
                  <div class="col-md-2">
                    <argon-button size="sm" class="bg-gray" type="submit">
                      Buscar
                    </argon-button>
                  </div>
                  <div class="col-md-2">
                    <input
                      class="form-control"
                      type="date"
                      placeholder="Fecha Inicio"
                      v-model="modelPagos.fechaInicio"
                    />
                  </div>
                     <div class="col-md-2">
                    <input
                      class="form-control"
                      type="date"
                      placeholder="Fecha Fin"
                      v-model="modelPagos.fechaFin"
                    />
                  </div>
                  <div class="col-md-2">
                    <argon-button size="sm" class="bg-gray" type="submit">
                      Filtro
                    </argon-button>
                  </div>
                </div>
               
              </form>
              <div v-if="tableData.length">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>RFC</th>
                        <th>Razon Social</th>
                        <th>Serie</th>
                        <th>Folio</th>
                        <th>Mensaje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in tableData" :key="index">
                        <td>{{ row.fechaTimbrado }}</td>
                        <td>{{ row.rfc }}</td>
                        <td>{{ row.razonSocial }}</td>
                        <td>{{ row.serie }}</td>
                        <td>{{ row.folio }}</td>
                        <td>{{ row.error }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- PAGINACIÓN -->
                <div class="d-flex justify-content-center py-3">
                  <argon-pagination color="primary" size="md">
                    <argon-pagination-item
                      prev
                      :disabled="currentPage === 1"
                      @click="changePage(currentPage - 1)"
                    />

                    <argon-pagination-item
                      v-for="page in totalPages"
                      :key="page"
                      :label="page.toString()"
                      :active="currentPage === page"
                      @click="changePage(page)"
                    />

                    <argon-pagination-item
                      next
                      :disabled="currentPage === totalPages"
                      @click="changePage(currentPage + 1)"
                    />
                  </argon-pagination>
                </div>
              </div>
              <div v-else class="text-center">Sin Pagos</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import historial from "../../api/historial";
// import Swal from "sweetalert2";
import PulseLoader from "../../../node_modules/vue-spinner/src/PulseLoader.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  components: {
    PulseLoader,
    ArgonPagination,
    ArgonPaginationItem,
    ArgonButton,
  },

  data() {
    return {
      totalFacturas: 0,
      perPage: 10,
      currentPage: 1,
      isLoading: false,
      color: "#535FA8",
      size: "45px",
      tableData: [],
      modelPagos: {
        filtro: "",
        fechaInicio: "",
        fechaFin: "",
        token: "",
        page: 1,
        offset: 0,
        limit: 10,
        statusPago: "ERROR",
      },
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalFacturas / this.perPage);
    },
  },

  created() {
    this.getData(1);
  },

  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;

      this.currentPage = page;
      this.getData(page);
    },

    getData(page = 1) {
      this.isLoading = true;

      const offset = (page - 1) * this.perPage;

      this.modelPagos.token = localStorage.getItem("token");
      this.modelPagos.offset = offset;
      this.modelPagos.limit = this.perPage;

      historial.getDataError(this.modelPagos).then((result) => {
        const resp = result.data;
        this.totalFacturas = resp.total;

        this.tableData = resp.data.map((item) => {
          console.log(item.response);
          return {
            fechaTimbrado: item.fechaInicio || "",
            serie: item.request.serie || "",
            folio: item.request.folio || "",
            rfc: item.request.receptor.rfc || "",
            razonSocial: item.request.receptor.razon_social || "",
            error: item.response.message || "",
          };
        });
        this.isLoading = false;
      });
    },
  },
};
</script>
